/*
 * Кольцо с акцентной дугой сверху. Кадры @keyframes spin и общий блок
 * prefers-reduced-motion живут в app/styles/base.css, здесь их нет.
 *
 * Геометрия ступеней — в токенах --spinner-size-* / --spinner-stroke-*, как и у Icon:
 * сырых значений в компонентных модулях не держим.
 */

.root {
  --spinner-size: var(--spinner-size-sm);
  --spinner-width: var(--spinner-stroke-sm);
  --spinner-track: var(--color-neutral-border);
  --spinner-arc: var(--color-accent);

  display: inline-block;
  flex: 0 0 auto;
  width: var(--spinner-size);
  height: var(--spinner-size);
  vertical-align: middle;
  border: var(--spinner-width) solid var(--spinner-track);
  border-top-color: var(--spinner-arc);
  border-radius: var(--radius-circle);
  animation: var(--anim-spin);
}

/* Внутри контрола: кнопка, чип, бейдж черновика, суффикс поля (кит 12/13/14/15) */
.xs {
  --spinner-size: var(--spinner-size-xs);
  --spinner-width: var(--spinner-stroke-xs);
}

/* Самостоятельная строка загрузки: футер подгрузки, пункт выпадашки (кит 16) */
.sm {
  --spinner-size: var(--spinner-size-sm);
  --spinner-width: var(--spinner-stroke-sm);
}

/* Центр карточки или секции, оверлей поверх блока (кит 20/22) */
.md {
  --spinner-size: var(--spinner-size-md);
  --spinner-width: var(--spinner-stroke-md);
}

/* Центр страницы или модалки, кольцо загрузки файла (кит 30/34) */
.lg {
  --spinner-size: var(--spinner-size-lg);
  --spinner-width: var(--spinner-stroke-lg);
}

/*
 * Дуга по цвету текста контейнера. Дорожка прозрачная: приглушить currentColor можно было бы
 * только через color-mix (Safari 16.2 при планке проекта 14), а пара токенов на каждый
 * возможный цвет подписи не существует. Кольцо остаётся читаемым одной дугой.
 */
.current {
  --spinner-track: transparent;
  --spinner-arc: currentcolor;
}

/* На синей и красной заливке, на тёмном тосте — белые в обеих темах */
.onAccent {
  --spinner-track: var(--color-track-on-accent);
  --spinner-arc: var(--color-text-on-accent);
}

/*
 * В режиме высокой контрастности Windows цвета рамок сбрасываются принудительно
 * и кольцо становится одноцветным — без этого блока индикатор пропадает.
 */
@media (forced-colors: active) {
  .root {
    border-color: Canvas;
    border-top-color: Highlight;
  }
}

/* Подпись слышна скринридеру и не занимает места в потоке */
.label {
  composes: visuallyHidden from '@/shared/styles/visuallyHidden.module.css';
}
